// Utils
import classnames from 'classnames'
import { SVGProps } from 'react'

import StarIcon from '../../../assets/star.inline.svg'
import Icon from '../../icon'

import styles from './reviewStars.module.scss'

interface ReviewStarsProps {
  totalStars: number
  fillStars: number
  className?: string
  classNameIcon?: string
  handleClick?: (star: number) => void
  starSvg?: ((any: any) => JSX.Element) | React.FC<SVGProps<SVGElement>>
  fillIconClass?: string
}

export const ReviewStars = ({ className = '', ...props }: ReviewStarsProps) => {
  const wrapClasses = classnames(styles.reviewStarsWrap, '', className)
  const NumberOfStarsSelected = (stars: number) => {
    if (typeof props.handleClick === 'function') props.handleClick(stars)
  }

  const getClassNames = (item: number) => {
    const ratingStar = item + 1 > Math.round(props.fillStars) ? styles.ratingStar : props.fillIconClass
    const classses = !props.starSvg
      ? classnames(styles.starIcon, props.classNameIcon, ratingStar)
      : item < Math.round(props.fillStars)
        ? classnames(styles.starIcon, props.classNameIcon, props.fillIconClass ?? styles.fillStar)
        : classnames(styles.starIcon, props.classNameIcon)
    return classses
  }

  const Star = props.starSvg ?? StarIcon

  return (
    <div className={wrapClasses}>
      {[...Array(props.totalStars)].map((value, item) => {
        return (
          <Icon
            key={item}
            iconSvg={Star}
            onClick={() => {
              NumberOfStarsSelected(item)
            }}
            className={`${getClassNames(item)} star_review_${item}`}
          />
        )
      })}
    </div>
  )
}

export default ReviewStars
